import { PROPERTY_LOOP_MERGE } from 'data/nodeProperties';

export const MARK_TAGS = {
  em: 'italic',
  strong: 'bold',
  u: 'underline',
  color: 'color',
};

export const HOTKEYS = {
  'mod+i': 'italic',
  'mod+b': 'bold',
  'mod+u': 'underline',
};

export const BLANK_PIPING_ANSWER = '____';

export const MENTION_TYPES = {
  QUESTION: 'question',
  LOOP_AND_MERGE: PROPERTY_LOOP_MERGE,
};

export const PIPE_EXPRESSION_MATCHING = {
  REF_ID: 1,
  SUB_REF_ID: 3,
  ATTRIBUTE_REF_ID: 4,
};

export const MULTIPLE_RECALL_OPTIONS_COUNT = [
  MENTION_TYPES.QUESTION,
  MENTION_TYPES.LOOP_AND_MERGE,
].length;

export const MULTIPLE_RECALL_OPTIONS_INDEX_LOOP_AND_MERGE = 0;
export const MULTIPLE_RECALL_OPTIONS_INDEX_QUESTION = 1;
